<template>
    <div class="ax-down-box">
        <div v-if="data.fileName" class="item_content_name">
            <div class="label_box blue">
                <slot name="left"></slot>
                <slot name="fileName"> {{ data.fileName }}</slot>
            </div>
        </div>
        <slot name="right">
            <a v-if="type === 'ssc' && !data.isqiyuesuo" class="item_content_val" :href="'/api/saas/mobile/file/previewFile.do?fileId=' + data.fileId" @click="downLoadFile(data.fileId, $event)">
                <van-icon class-prefix="iconfont" name="down" />
            </a>
            <a v-if="type === 'ssc' && data.isqiyuesuo" class="item_content_val" :href="'/api/saas/mobile/file/getPreUrl.do?fileId=' + data.fileId">
                <van-icon class-prefix="iconfont" name="down" />
            </a>
            <a v-else-if="type === 'exp'" class="item_content_val" :href="
          '/api/exp/custom/ecAttachment?Q-CA-ApiKey=060aa495-c588-43a6-9ec8-7316d915b920&attachment_id=' +
            data.attachmentId
        " @click="downLoadExpFile(data.attachmentId, $event)">
                <van-icon class-prefix="iconfont" name="down" />
            </a>
        </slot>
    </div>
</template>

<script>
export default {
    name: "ax-item",
    props: {
        label: [String, Number],
        type: [String],
        data: [Object],
        blue: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "",
        },
    },
    methods: {
        downLoadFile(fileId, event) {
            iqh.preViewFile({
                fileId: fileId,
            });
            if (isAndroid) {
                event.preventDefault();
            }
        },
        downLoadExpFile(fileId, event) {
            iqh.preViewFileForFK({
                "Q-CA-ApiKey": "060aa495-c588-43a6-9ec8-7316d915b920",
                attachment_id: fileId,
            });
            if (isAndroid) {
                event.preventDefault();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ax-down-box {
    line-height: 22px;
    height: 22px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    font-size: 15px;
    color: rgba(0, 0, 0, 1);

    &:not(:first-child) {
        line-height: 32px;
        height: 32px;
    }

    .item_content_name {
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        max-width: 200px;

        .label_box {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.blue {
                font-size: 14px;
                color: $file-color;
            }
        }

        .brief_box {
            font-size: 12px;
            line-height: 1.4;
        }
    }

    .item_content_val {
        min-height: 22px;
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        word-break: break-all;

        .iconfont {
            color: #ccc;
            font-size: 20px;
        }
    }
}

.out-down {
    padding: 11px 16px;

    &:not(:first-child) {
        line-height: 22px;
        height: 22px;
    }

    .item_content_name {
        max-width: 260px;
    }
}

.exp-panel {
    .out-down {
        padding-left: 0;
    }
}
</style>
